import { Drawer } from "@mui/material";
import React, { useContext } from "react";
import BSSDataContext from "../../contexts/BSSDataContext";
import useBSSLogger from "../../hooks/useBSSLogger";

const {logger} = useBSSLogger();

const BSSDrawer = ({children, ...DrawerProps}) => {

    const {shadowBody} = useContext(BSSDataContext);
    logger.debug("test shadowbody per BSSDrawer", DrawerProps.container, shadowBody)

    DrawerProps = {...{
        disablePortal: true,
        container: shadowBody,
        //zIndex: 99999999,
    }, ...DrawerProps}


    return (
        <>
            <Drawer {...DrawerProps}>
                {children}
            </Drawer>
        </>
    )
}

export default BSSDrawer